import React, { useCallback } from 'react';
import { Route, useLocation } from 'react-router-dom';
import { BottomNavigation } from '@nykaa/bottom-navigation/dist/components/BottomNavBar';
import styled from 'App/styled';
import routes from 'routeConfig';
import { useSelector } from 'react-redux';
import { State } from 'store/types';

const StickyBottomNav = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  @media (min-width: 640px) {
    max-width: 640px;
    margin: 0 auto;
  }
`;

const routesWithBottomNav: string[] = [];
routes?.forEach((route) => {
  if (route?.bottomNav) {
    const paths = Array.isArray(route.path) ? route.path : [route.path];
    routesWithBottomNav.push(...paths);
  }
});

const BottomNavBarView: React.FC = React.memo(() => {
  const location = useLocation();
  const currentUrl = location.pathname;

  const bottomNavConfig =
    useSelector(
      (state: State) => state.remoteConfig.configs?.bottomNavigationBar
    ) || {};

  const navigate = useCallback(
    (url: string) => {
      // Only navigate if we're not already on the target URL
      if (currentUrl === url?.split('?')[0]) {
        return;
      }

      window.location.href = url;
    },
    [currentUrl]
  );

  return (
    <StickyBottomNav>
      <BottomNavigation
        bottomNavConfig={bottomNavConfig}
        currentUrl={currentUrl}
        navigate={navigate}
      />
    </StickyBottomNav>
  );
});

BottomNavBarView.displayName = 'BottomNavBarView';

export const BottomNavBar: React.FC = () => (
  <Route
    path={routesWithBottomNav}
    exact
  >
    <BottomNavBarView />
  </Route>
);
